<template>
  <v-container>
    <v-form v-model="formulaire" ref="formCni" lazy-validation>
      <v-overlay :value="$storeBourse.loader">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-card
        elevation="2"
        width="90%"
        class="pa-md-4 mx-auto"
        v-if="!$storeBourse.verificationCni.afficherMessage"
      >
        <v-card-title>
          <h2 style="color: #0d263c">Merci de renseigner votre numéro CNI</h2>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="8">
              <v-text-field
                label="Numéro de CNI"
                v-model="$storeBourse.verificationCni.cni"
                :rules="$storeReglesBourse.obligatoire"
              />
            </v-col>
            <v-col cols="4">
              <v-btn
                x-large
                dark
                color="ecSecondary"
                @click.native="CheckCni()"
              >
                Vérifier
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card elevation="2" width="90%" class="pa-md-4 mx-auto" v-else>
        <v-card-text>
          <div v-if="$storeBourse.verificationCni.cniVerifie">
            <div v-if="!$storeBourse.verificationCni.candidatureExistante">
              <p>Votre n° CNI a été vérifié.</p>
              <p>
                Pour poursuivre votre dossier, merci de cliquer sur le bouton
                ci-dessous.
              </p>
              <v-btn large dark @click="RedirectionFormulaire">Continuer</v-btn>
            </div>
            <div v-else>
              <p>
                Il y a déjà une candidature existante avec le même CNI. Veuillez
                vous connecter directement sur
                <a :href="LienPortail" target="_blank">l'extranet.</a>
              </p>
            </div>
          </div>
          <div v-else>
            <p>
              Le numéro de CNI n'est pas renseigné dans notre base de données.
              Veuillez vous rapprocher de votre contact administratif chez Ecole
              Centrale Casablance.
            </p>
          </div>
        </v-card-text>
      </v-card>
    </v-form>
  </v-container>
</template>
<script>
export default {
  name: "VerificationCni",
  data() {
    return {
      formulaire: false,
      $storeReglesBourse: this.$storeReglesBourse,
      $storeBourse: this.$storeBourse,
      LienPortail: process.env.VUE_APP_LIEN_PORTAIL_ECOLE_CENTRALE,
    };
  },
  methods: {
    CheckCni() {
      if (this.$refs.formCni.validate()) {
        this.$storeBourse.CheckCni(
          this.$storeBourse.verificationCni.cni,
          false
        );
      }
    },
    RedirectionFormulaire() {
      this.$router.push({
        path:
          "dossierboursecentrale/" +
          this.$storeBourse.verificationCni.cniVerifie,
      });
    },
  },
  created() {
    this.LienPortail = process.env.VUE_APP_LIEN_PORTAIL_ECOLE_CENTRALE;
  },
  mounted() {
    this.$storeBourse.loader = false;
  },
};
</script>
